import React, { useState } from 'react';
import axios from 'axios';

const API = '/api';

function Upgrade() {
  const [loading, setLoading] = useState(null);

  const handleUpgrade = async (plan) => {
    setLoading(plan);
    try {
      const res = await axios.post(`${API}/stripe/create-checkout`, { plan });
      window.location.href = res.data.url;
    } catch (err) {
      console.error(err);
      setLoading(null);
    }
  };

  return (
    <div>
      <h1>Upgrade auf Pro</h1>
      <p style={{ color: '#718096', marginBottom: '2rem' }}>
        Schalte alle Funktionen frei und lerne ohne Einschränkungen.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem' }}>

        {/* Free */}
        <div className="card" style={{ opacity: 0.7 }}>
          <h2>Free</h2>
          <div style={{ fontSize: '2rem', fontWeight: '700', color: '#4c51bf', margin: '1rem 0' }}>
            CHF 0
          </div>
          <ul style={{ listStyle: 'none', marginBottom: '1.5rem' }}>
            {['50 Lernkarten', '3 Kategorien', 'DeepL Übersetzung', 'Bibliothek lesen'].map(f => (
              <li key={f} style={{ padding: '0.4rem 0', borderBottom: '1px solid #e2e8f0', fontSize: '0.9rem' }}>
                ✓ {f}
              </li>
            ))}
          </ul>
          <div style={{ textAlign: 'center', color: '#718096', padding: '0.75rem' }}>
            Aktueller Plan
          </div>
        </div>

        {/* Pro */}
        <div className="card" style={{ border: '2px solid #4c51bf' }}>
          <div style={{ background: '#ebf4ff', color: '#2b6cb0', fontSize: '0.75rem', fontWeight: '600', padding: '0.25rem 0.75rem', borderRadius: '20px', display: 'inline-block', marginBottom: '0.75rem' }}>
            Empfohlen
          </div>
          <h2>Pro</h2>
          <div style={{ fontSize: '2rem', fontWeight: '700', color: '#4c51bf', margin: '1rem 0' }}>
            CHF 4.90 <span style={{ fontSize: '1rem', fontWeight: '400', color: '#718096' }}>/Monat</span>
          </div>
          <ul style={{ listStyle: 'none', marginBottom: '1.5rem' }}>
            {['Unbegrenzt Karten', 'Unbegrenzt Kategorien', 'Bibliothek importieren', 'Auswertungen & Statistiken', 'Keine Werbung'].map(f => (
              <li key={f} style={{ padding: '0.4rem 0', borderBottom: '1px solid #e2e8f0', fontSize: '0.9rem' }}>
                ✓ {f}
              </li>
            ))}
          </ul>
          <button className="btn-primary" style={{ width: '100%' }}
            onClick={() => handleUpgrade('pro')} disabled={loading === 'pro'}>
            {loading === 'pro' ? 'Weiterleitung...' : 'Pro aktivieren'}
          </button>
        </div>

        {/* Team */}
        <div className="card">
          <h2>Schule / Team</h2>
          <div style={{ fontSize: '2rem', fontWeight: '700', color: '#4c51bf', margin: '1rem 0' }}>
            CHF 19.90 <span style={{ fontSize: '1rem', fontWeight: '400', color: '#718096' }}>/Monat</span>
          </div>
          <ul style={{ listStyle: 'none', marginBottom: '1.5rem' }}>
            {['Alles aus Pro', 'Bis 30 Benutzer', 'Admin Dashboard', 'Sets teilen', 'Rechnung & MwSt.'].map(f => (
              <li key={f} style={{ padding: '0.4rem 0', borderBottom: '1px solid #e2e8f0', fontSize: '0.9rem' }}>
                ✓ {f}
              </li>
            ))}
          </ul>
          <button className="btn-primary" style={{ width: '100%', background: '#2b6cb0' }}
            onClick={() => handleUpgrade('team')} disabled={loading === 'team'}>
            {loading === 'team' ? 'Weiterleitung...' : 'Team aktivieren'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Upgrade;